
import { Component, OnInit } from '@angular/core';
import { ProductTelephoneCompanyService } from '../../../services/product-telephone-company.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-telephone-companies',
  templateUrl: './list-product-telephone-companies.component.html',
  styleUrls: ['./list-product-telephone-companies.component.css'],
  providers:[ProductTelephoneCompanyService,ProductService]
})
export class ListProductTelephoneCompaniesComponent implements OnInit {

  productTelephoneCompanies:any = [];

  constructor(private productTelephoneCompanyService:ProductTelephoneCompanyService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductStorageCapacities();
  }

  getProductStorageCapacities(){
    this.productTelephoneCompanyService.query({})
      .subscribe((productTelephoneCompanies) => {
        this.productTelephoneCompanies = productTelephoneCompanies;
        this.parseProducts();
      });
  }

  delete(productTelephoneCompany){
    this.productService.query({telephone_company:productTelephoneCompany.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productTelephoneCompanyService.delete(productTelephoneCompany.id)
        .subscribe((productStorageCapacity) => {
          this.getProductStorageCapacities()
        });
      }
    });
  }

  parseProducts(){
    this.productTelephoneCompanies.forEach(function (productTelephoneCompany){
      productTelephoneCompany.productTypes = "";
      if(productTelephoneCompany.product_types.includes("1")){
        productTelephoneCompany.productTypes += "Móviles y Tablets,";
      }
      if(productTelephoneCompany.product_types.includes("2")){
        productTelephoneCompany.productTypes += "Consolas,";
      }
      if(productTelephoneCompany.product_types.includes("3")){
        productTelephoneCompany.productTypes += "Artículos Varios,";
      }
      if(productTelephoneCompany.product_types.includes("4")){
        productTelephoneCompany.productTypes += "PC's-portátiles,";
      }
      productTelephoneCompany.productTypes = productTelephoneCompany.productTypes.substring(0,productTelephoneCompany.productTypes.length - 1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-telephone-companies/list-product-telephone-companies/list-product-telephone-companies.component.ts